import _slicedToArray from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { rad2deg as t } from "../../../core/mathUtils.js";
import { create as n } from "../../../geometry/support/aaBoundingRect.js";
import { getRingsOrPathsBounds as e } from "../../../geometry/support/boundsUtils.js";
import { geometryToCoordinates as o } from "../../../geometry/support/coordsUtils.js";

function r(t, n, e, r) {
  if (null == r || t.hasZ || (r = void 0), "point" === t.type) return t.x += n, t.y += e, t.hasZ && null != r && (t.z += r), t;

  if ("multipoint" === t.type) {
    var _o = t.points;

    for (var _t = 0; _t < _o.length; _t++) {
      _o[_t] = l(_o[_t], n, e, r);
    }

    return t;
  }

  if ("extent" === t.type) return t.xmin += n, t.xmax += n, t.ymin += e, t.ymax += e, null != r && (t.zmin += r, t.zmax += r), t;
  var s = o(t),
      i = "polyline" === t.type ? t.paths : t.rings;

  for (var _o2 = 0; _o2 < s.length; _o2++) {
    var _t2 = s[_o2];

    for (var _o3 = 0; _o3 < _t2.length; _o3++) {
      _t2[_o3] = l(_t2[_o3], n, e, r);
    }
  }

  return "paths" in t ? t.paths = i : t.rings = i, t;
}

function s(t, n, e, s, i) {
  var a = t.clone(),
      m = s.resolution;

  if ("point" === a.type) {
    if (i) r(a, n * m, -e * m);else {
      var _t3 = s.state.transform,
          _o4 = s.state.inverseTransform,
          _r = _t3[0] * a.x + _t3[2] * a.y + _t3[4],
          _i = _t3[1] * a.x + _t3[3] * a.y + _t3[5];

      a.x = _o4[0] * (_r + n) + _o4[2] * (_i + e) + _o4[4], a.y = _o4[1] * (_r + n) + _o4[3] * (_i + e) + _o4[5];
    }
    return a;
  }

  if ("multipoint" === a.type) {
    if (i) r(a, n * m, -e * m);else {
      var _t4 = a.points,
          _o5 = s.state.transform,
          _r2 = s.state.inverseTransform;

      for (var _s = 0; _s < _t4.length; _s++) {
        var _i2 = _t4[_s],
            _a = _o5[0] * _i2[0] + _o5[2] * _i2[1] + _o5[4],
            _m = _o5[1] * _i2[0] + _o5[3] * _i2[1] + _o5[5],
            _l = _r2[0] * (_a + n) + _r2[2] * (_m + e) + _r2[4],
            p = _r2[1] * (_a + n) + _r2[3] * (_m + e) + _r2[5];

        _t4[_s] = x(_i2, _l, p, void 0);
      }
    }
    return a;
  }

  if ("extent" === a.type) {
    if (i) r(a, n * m, -e * m);else {
      var _t5 = s.state.transform,
          _o6 = s.state.inverseTransform,
          _r3 = _t5[0] * a.xmin + _t5[2] * a.ymin + _t5[4],
          _i3 = _t5[1] * a.xmin + _t5[3] * a.ymin + _t5[5],
          _m2 = _t5[0] * a.xmax + _t5[2] * a.ymax + _t5[4],
          _l2 = _t5[1] * a.xmax + _t5[3] * a.ymax + _t5[5];

      a.xmin = _o6[0] * (_r3 + n) + _o6[2] * (_i3 + e) + _o6[4], a.ymin = _o6[1] * (_r3 + n) + _o6[3] * (_i3 + e) + _o6[5], a.xmax = _o6[0] * (_m2 + n) + _o6[2] * (_l2 + e) + _o6[4], a.ymax = _o6[1] * (_m2 + n) + _o6[3] * (_l2 + e) + _o6[5];
    }
    return a;
  }

  if (i) r(a, n * m, -e * m);else {
    var _t6 = o(a),
        _r4 = "polyline" === a.type ? a.paths : a.rings,
        _i4 = s.state.transform,
        _m3 = s.state.inverseTransform;

    for (var _o7 = 0; _o7 < _t6.length; _o7++) {
      var _r5 = _t6[_o7];

      for (var _t7 = 0; _t7 < _r5.length; _t7++) {
        var _o8 = _r5[_t7],
            _s2 = _i4[0] * _o8[0] + _i4[2] * _o8[1] + _i4[4],
            _a2 = _i4[1] * _o8[0] + _i4[3] * _o8[1] + _i4[5],
            _l3 = _m3[0] * (_s2 + n) + _m3[2] * (_a2 + e) + _m3[4],
            _p = _m3[1] * (_s2 + n) + _m3[3] * (_a2 + e) + _m3[5];

        _r5[_t7] = x(_o8, _l3, _p, void 0);
      }
    }

    "paths" in a ? a.paths = _r4 : a.rings = _r4;
  }
  return a;
}

function i(t, r, s, i) {
  if ("point" === t.type) {
    var _n = t.x,
        _e = t.y,
        _o9 = i ? i[0] : _n,
        _a3 = i ? i[1] : _e,
        _m4 = t.clone(),
        _l4 = (_n - _o9) * r + _o9,
        _x = (_e - _a3) * s + _a3;

    return _m4.x = _l4, _m4.y = _x, _m4;
  }

  if ("multipoint" === t.type) {
    var _a4 = o(t),
        _m5 = n(),
        _e2 = e(_m5, [_a4]),
        _e3 = _slicedToArray(_e2, 4),
        _l5 = _e3[0],
        _p2 = _e3[1],
        _y = _e3[2],
        _f = _e3[3],
        _u = i ? i[0] : (_l5 + _y) / 2,
        _c = i ? i[1] : (_f + _p2) / 2,
        _h = t.clone(),
        _g = _h.points;

    for (var _t8 = 0; _t8 < _g.length; _t8++) {
      var _n2 = _g[_t8],
          _n3 = _slicedToArray(_n2, 2),
          _e4 = _n3[0],
          _o10 = _n3[1],
          _i5 = (_e4 - _u) * r + _u,
          _a5 = (_o10 - _c) * s + _c;

      _g[_t8] = x(_n2, _i5, _a5, void 0);
    }

    return _h;
  }

  if ("extent" === t.type) {
    var _n4 = t.xmin,
        _e5 = t.xmax,
        _o11 = t.ymin,
        _a6 = t.ymax,
        _m6 = i ? i[0] : (_n4 + _e5) / 2,
        _l6 = i ? i[1] : (_a6 + _o11) / 2,
        _x2 = t.clone();

    if (_x2.xmin = (_n4 - _m6) * r + _m6, _x2.ymax = (_a6 - _l6) * s + _l6, _x2.xmax = (_e5 - _m6) * r + _m6, _x2.ymin = (_o11 - _l6) * s + _l6, _x2.xmin > _x2.xmax) {
      var _t9 = _x2.xmin,
          _n5 = _x2.xmax;
      _x2.xmin = _n5, _x2.xmax = _t9;
    }

    if (_x2.ymin > _x2.ymax) {
      var _t10 = _x2.ymin,
          _n6 = _x2.ymax;
      _x2.ymin = _n6, _x2.ymax = _t10;
    }

    return _x2;
  }

  var a = o(t),
      m = n(),
      _e6 = e(m, a),
      _e7 = _slicedToArray(_e6, 4),
      l = _e7[0],
      p = _e7[1],
      y = _e7[2],
      f = _e7[3],
      u = i ? i[0] : (l + y) / 2,
      c = i ? i[1] : (f + p) / 2,
      h = t.clone(),
      g = "polyline" === h.type ? h.paths : h.rings;

  for (var _n7 = 0; _n7 < a.length; _n7++) {
    var _t11 = a[_n7];

    for (var _e8 = 0; _e8 < _t11.length; _e8++) {
      var _o12 = _t11[_e8],
          _o13 = _slicedToArray(_o12, 2),
          _i6 = _o13[0],
          _a7 = _o13[1],
          _m7 = (_i6 - u) * r + u,
          _l7 = (_a7 - c) * s + c;

      g[_n7][_e8] = x(_o12, _m7, _l7, void 0);
    }
  }

  return "paths" in h ? h.paths = g : h.rings = g, h;
}

function a(t, n, e, o, r, s) {
  var i = Math.sqrt((e - t) * (e - t) + (o - n) * (o - n));
  return Math.sqrt((r - t) * (r - t) + (s - n) * (s - n)) / i;
}

function m(n, e, o) {
  var r = Math.atan2(e.y - o.y, e.x - o.x) - Math.atan2(n.y - o.y, n.x - o.x),
      s = Math.atan2(Math.sin(r), Math.cos(r));
  return t(s);
}

function l(t, n, e, o) {
  return x(t, t[0] + n, t[1] + e, null != t[2] && null != o ? t[2] + o : void 0);
}

function x(t, n, e, o) {
  var r = [n, e];
  return t.length > 2 && r.push(null != o ? o : t[2]), t.length > 3 && r.push(t[3]), r;
}

export { s as cloneMove, m as getRotationAngle, a as getScaleRatio, r as move, i as scale };